import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticateRequest, AuthenticateResponse, AuthorizeResponse } from 'src/app/models/authenticate.model';
import { UserDetails } from 'src/app/models/user-details.model';
import { AppConfigService } from 'src/app/config/appconfig.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/storage.service';
import { ACTIVE_POLICY_PAYMENT_CONTENT, GRACE_PAYMENT_CONTENT, INITIAL_PAYMENT_CONTENT, PolicySearchContent } from 'src/app/utils/utils.constants';

@Component({
  selector: 'app-policy-search',
  templateUrl: './policy-search.component.html',
  styleUrls: ['./policy-search.component.scss']
})
export class PolicySearchComponent {

  policySearchForm: FormGroup;
  isPendingPolicy: boolean;

  policyNotFoundError: boolean = false;
  noBillFoundError: boolean = false;
  submitted = false;
  isGracePayment: boolean= false;
  content: PolicySearchContent = INITIAL_PAYMENT_CONTENT;

  constructor(private router: Router, private route: ActivatedRoute, private fb: FormBuilder, private authService:AuthService,
    private loaderService:LoaderService, private storageService: StorageService, private config: AppConfigService) {
    this.isGracePayment = this.route.snapshot.fragment === 'grace-payment';

    this.config.setIsGracePayment(this.isGracePayment);
    
    let isPendingPolicy = this.storageService.getIsPendingPolicy();

    if (isPendingPolicy == null && !this.isGracePayment) {
      this.onBack();
      return;
    }

    this.isPendingPolicy = isPendingPolicy ?? false;
    if (this.isGracePayment) {
      this.content = GRACE_PAYMENT_CONTENT;
    } else {
      this.content = this.isPendingPolicy ? ACTIVE_POLICY_PAYMENT_CONTENT : INITIAL_PAYMENT_CONTENT;
    }
    this.policySearchForm = this.fb.group({
      policyNumber: ['', [Validators.required]],
      zipCode: ['', [Validators.required]],
      phoneNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]]
    });
  }

  onSubmit() {
    this.policyNotFoundError = false;
    this.noBillFoundError = false;
    this.submitted = true;
    if (this.policySearchForm.valid) {
      this.loaderService.showLoader();
      let values = this.policySearchForm.value
      let request:AuthenticateRequest={
        policyNumber: values.policyNumber,
        phoneNumber: values.phoneNumber,
        postalCode: values.zipCode,
        isGracePayment: this.isGracePayment
      }
      this.authService.policySearch(request).subscribe({
        next: (response: AuthenticateResponse) => {
          this.getToken(response.assertion);
        },
        error: (error) => {
          this.policyNotFoundError = true;
          this.loaderService.hideLoader();
          window.scrollTo(0, 0);
        }
      })
    } else {
      this.policySearchForm.markAllAsTouched();
      window.scrollTo(0, 0);
    }

  }

  getToken(assertion:string){
    this.authService.authorize(assertion).subscribe({
      next: (response: AuthorizeResponse) => {
        if(response.access_token){
          this.storageService.setAccessToken('Bearer ' + response.access_token);
        }
        this.getUserInfo();
      },
      error: (error) => {
        this.policyNotFoundError = true;
        this.loaderService.hideLoader();
        window.scrollTo(0, 0);
      }
    })
  }

  getUserInfo() {
    let mode ="";
    if(this.isGracePayment){
      mode = "gracePayment";
    } else if (this.isPendingPolicy){
      mode = "default";
    } else {
      mode = "initialPremium";
    }
    this.authService.getUserDetails(mode).subscribe({
      next: (response: UserDetails) => {
        if(response){
           if(this.isGracePayment){
            if(!response.graceEligibility){
              this.policyNotFoundError = true;
              this.loaderService.hideLoader();
              window.scrollTo(0, 0);
              return;
            }
           }
           // grace payment only checks zero balance; other flows also require allowPayments
           if(response.balance === 0  || (!this.isGracePayment && !response.allowPayments)){            
            this.noBillFoundError = true;
            this.loaderService.hideLoader();
            window.scrollTo(0, 0);
            return;
           }
          this.storageService.setUserInfo(response);
        }
        this.router.navigateByUrl('/policy-found');
      },
      error: (error) => {
        this.policyNotFoundError = true;
        this.loaderService.hideLoader();
        window.scrollTo(0, 0);
      }   
    })
  }
  

  onBack() {
    this.router.navigateByUrl('/home');
  }

  onCancel() {
    window.location.href = ' https://www.nationwide.com/personal/member-services/pay-bill?utm_campaign=pl-sitelink&utm_medium=Search&utm_source=Bing&utm_content=All:PL:REP:NA:NA&utm_term=www%20nation&&msclkid=74591eadb69016dcc7837bfa31491e5d&gclid=74591eadb69016dcc7837bfa31491e5d&gclsrc=3p.ds';
  }

}
